module.exports = __webpack_public_path__ + "img/captions.f9b46705.svg";